import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import {
  useCreateFormTagMutation,
  useUpdateFormTagMutation,
} from '@/modules/admin-dashboard/queries/form-tags.ts';
import { BaseModalProps, Button, ModalContentWrapper, TextInputField } from 'ui';
import { TagResponse } from 'compliance-api';

export interface FormTagModalProps extends BaseModalProps {
  tag: TagResponse;
}

const validationSchema = yup.object({
  name: yup.string().min(3).max(100).required('Please write some name'),
});

const initialValues = { name: '' };

export const FormTagModal = ({ tag, open, onClose }: FormTagModalProps) => {
  const { mutateAsync: createTag, isLoading } = useCreateFormTagMutation();
  const { mutateAsync: updateTag } = useUpdateFormTagMutation();

  const formik = useFormik({
    initialValues: tag ? { name: tag.name } : initialValues,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      if (tag) {
        await updateTag({ name: values.name, id: tag.id });
      } else {
        await createTag(values);
      }
      resetForm();
      onClose();
    },
  });

  return (
    <ModalContentWrapper
      open={open}
      title={tag ? 'Update form category' : 'Add new form category'}
      onClose={onClose}
    >
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col items-center gap-4" onClick={e => e.preventDefault()}>
          <TextInputField
            value={formik.values.name}
            name="name"
            label="category name"
            placeholder="Some name..."
          />
          <Button
            type="submit"
            onClick={formik.submitForm}
            disabled={isLoading}
            loading={isLoading}
          >
            {tag ? 'Update category' : 'Add category'}
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
